var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreOptionsSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 13,
    viewBox: "0 0 3 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62565 0.8125C0.915234 0.8125 0.333984 1.39375 0.333984 2.10417C0.333984 2.81458 0.915234 3.39583 1.62565 3.39583C2.33607 3.39583 2.91732 2.81458 2.91732 2.10417C2.91732 1.39375 2.33607 0.8125 1.62565 0.8125ZM1.62565 9.85416C0.915234 9.85416 0.333984 10.4354 0.333984 11.1458C0.333984 11.8562 0.915234 12.4375 1.62565 12.4375C2.33607 12.4375 2.91732 11.8562 2.91732 11.1458C2.91732 10.4354 2.33607 9.85416 1.62565 9.85416ZM1.62565 5.33333C0.915234 5.33333 0.333984 5.91458 0.333984 6.625C0.333984 7.33541 0.915234 7.91666 1.62565 7.91666C2.33607 7.91666 2.91732 7.33541 2.91732 6.625C2.91732 5.91458 2.33607 5.33333 1.62565 5.33333Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptionsSmallIcon);
export default __webpack_public_path__ + "static/media/more-options-small-icon.5ec54586b3d96276f214fb51ad8e465d.svg";
export { ForwardRef as ReactComponent };